import styled from 'styled-components'

export const Button = styled.button`
padding: 1rem 3rem;
box-sizing: border-box;
border-radius: 5px;
cursor: pointer;
text-transform: capitalize;
font-weight: bold;
margin-right: 10px;
font-size: 1.3rem;
text-decoration: none;
box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;
transition: all 0.3s ease;
letter-spacing: 1.45px;
line-height: 1.5;
white-space: normal;
text-align: center;
display: inline-block;
vertical-align: middle;
user-select: none;

&:hover {
    text-decoration: none;
}
`

export const PrimaryButton = styled(Button)`
background: #5D3EDC;
color: white;
border: 1px solid #5D3EDC;

&:hover {
    background: #261370;
}
`

export const SecondaryButton = styled(Button)`
background: white;
color: #5D3EDC;
border: 1px solid #5D3EDC;

&:hover {
    background: #ece8ff;
}
`

export const DangerButton = styled(Button)`
background: #ff4a59;
color: white;
border: none;

&:hover {
    background-color: #c71c2b;
}
`

export const LinkButton = styled(Button)`
border: none;
color: #333333;
background-color: white;
box-shadow: none !important;
`


export const ButtonLink = styled.a`
padding: 1rem 1.5rem;
box-sizing: border-box;
border-radius: 5px;
cursor: pointer;
text-transform: capitalize;
font-weight: bold;
margin-right: 10px;
font-size: 1.3rem;
text-decoration: none;
box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
-webkit-box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);

transition: all 0.3s ease;
letter-spacing: 1.45px;
line-height: 1.5;
white-space: normal;
text-align: center;
display: inline-block;
vertical-align: middle;
user-select: none;

&:hover {
    text-decoration: none;
}
`

export const PrimaryButtonLink = styled(ButtonLink)`
background: #5D3EDC;
color: white;
border: 1px solid #5D3EDC;

&:hover {
    background: #261370;
}
`

export const SecondaryButtonLink = styled(ButtonLink)`
background: white;
color: #5D3EDC;
border: 1px solid #5D3EDC;

&:hover {
    background: #ece8ff;
}
`
export const DangerButtonLink = styled(ButtonLink)`
background: #ff4a59;
color: white;
border: none;

&:hover {
    background-color: #c71c2b;
}
`